import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { WebShopService } from "../../services/webShop.service";
import { Router } from "@angular/router";
import { plopInOut } from "../../shared/animation/component.animation";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import Utils from "../../shared/utils";
import { CoreLogService } from "../../services/log.service";

interface ExtrItemConfig {
  id: number;
  label: string;
  count: number;
  subIndex: number;
}

interface ItemConfigData {
  id: number;
  image: string;
  label: string;
  price: number;
  count: number;
  extras: ExtrItemConfig[];
  itemGroupId: number;
  canComment: boolean;
  comment?: string;
}

interface Article {
  Id: number,
  Count: number,
  Comment: string,
  Extras: Extra[],
}

interface Extra {
  Id: number,
  Count: number,
}

@Component({
  selector: "remoteGroupContinueOrderDialog",
  templateUrl: "./remoteGroupContinueOrderDialog.component.html",
  styleUrls: ["./remoteGroupContinueOrderDialog.component.scss"],
  animations: [plopInOut]
})

export class RemoteGroupContinueOrderDialogComponent implements OnInit {

  public userId: number;
  public commentVisibleInitilize: boolean = true;

  @ViewChild('commentBox') commentBox: ElementRef<HTMLTextAreaElement>;

  constructor(public bottomSheetRef: MatBottomSheetRef<RemoteGroupContinueOrderDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalData: ItemConfigData
    , private _webShopService: WebShopService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService) {
  }

  ngOnInit() {
    const me = this;
    me.userId = me._remoteGroupOrderService.userId;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteGroupContinueOrderDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public priceFormatter(price: number): string {
    const me = this;
    return me._webShopService.formatCurrency(price);
  }

  public setItemPrice() {
    const me = this;
    const itemprice = (me.modalData.price) * me.modalData.count;
    return me.priceFormatter(itemprice)
  }

  public setExtraString(): string {
    return this.modalData.extras.filter(e => e.subIndex >= 0).map(e => {
      const single = (e.count > 1 ? e.count + "x " : "") + e.label;
      if (e.subIndex > 0) {
        const subExtras = this.modalData.extras.filter(s => s.subIndex === -e.subIndex);
        if (subExtras.length > 0) {
          return single + "(" + subExtras.map(s => (s.count > 1 ? s.count + "x " : "") + s.label).join(", ") + ")";
        }
      } else {
        return single;
      }
    }).join(", ");
  }

  public showComment() {
    const me = this;
    return me.modalData.canComment && !Utils.IsNullOrEmpty(me.modalData.comment);
  }

  private async setComment() {
    const me = this;
    if (!Utils.IsNullOrEmpty(me.modalData.comment)) {
      const article: Article = {
        Id: me.modalData.id,
        Count: me.modalData.count,
        Comment: me.modalData.comment,
        Extras: this.modalData.extras.map(extra => ({ Id: extra.id, Count: extra.count }))
      };
      await me._remoteGroupOrderService.addComment(article);
    }
  }

  public closeEmptyTextArea(newText: string, itemID: number) {
    const me = this;
    if (!newText) {
      const itemComment = document.getElementById(`comment${itemID}`);
      const commentLink = document.getElementById(`commentLink${itemID}`);
      itemComment.classList.add("hide-comment");
      commentLink.classList.add("show-anmerkung");
      itemComment.classList.remove("show-comment");
      commentLink.classList.remove("hide-anmerkung");
      me.commentVisibleInitilize = false;
    }
  }

  // open comment text for an item
  public toggleCommentArea(itemID: number) {
    const me = this;
    const itemComment = document.getElementById(`comment${itemID}`);
    const commentLink = document.getElementById(`commentLink${itemID}`);
    itemComment.classList.add("show-comment");
    commentLink.classList.add("hide-anmerkung");
    itemComment.classList.remove("hide-comment");
    commentLink.classList.remove("show-anmerkung");
    me.commentVisibleInitilize = false;
    setTimeout(() => {
      (itemComment.firstChild as HTMLElement).focus();
    }, 600);
  }

  /** Changes the state to 'Ready'*/
  public async navigateToBasket(userId: number, ready: boolean) {
    const me = this;
    if (!Utils.IsNull(userId)) {
      await me._remoteGroupOrderService.changeAndSetUserStateReady(userId, ready);
      await me.setComment();
      me._router.navigate(["/remoteOrderGroupOverview"]);
      me.PushChanges();
    }
    me.bottomSheetRef.dismiss();
  }

  private _setNavigationOnContinue() {
    const me = this;
    const itemGroupID = me.modalData.itemGroupId
    if (itemGroupID && itemGroupID > 0) {
      me._router.navigate(["/menu", me.modalData.itemGroupId]);
    }
  }

  public async continue() {
    const me = this;
    me._setNavigationOnContinue();
    await me.setComment();
    me.bottomSheetRef.dismiss();
  }
}
